export const useCanonical = () => {
  const url = useRuntimeConfig().public.applicationUrl || ''
  const $route = useRoute()

  if (url) {
    useHead({
      link: [
        {
          hid: 'canonical',
          rel: 'canonical',
          href: $route.path === '/' ? url : url + $route.path,
        },
      ],
    })
  }
}
